import axios from "axios";
import * as actions from "../api";
import { baseURL, emsList } from "../../utility/Constants";

const api =
  ({ dispatch }) =>
  (next) =>
  async (action) => {
    if (action.type !== actions.apiCallBegan.type) return next(action);

    const { url, method, data, onStart, onSuccess, onError } = action.payload;

    if (onStart) dispatch({ type: onStart });
    next(action);

    try {
      const response = await axios.request({
        baseURL,
        url,
        method,
        data,
      });

      dispatch(actions.apiCallSuccess(response.data));

      if (onSuccess) dispatch({ type: onSuccess, payload: response.data });
    } catch (err) {
      dispatch(actions.apiCallFailed(err.message));
      if (onError) dispatch({ type: onError, payload: err.message });
    }
  };

export default api;
